import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "VisitStoreToPurchase" */ './VisitStoreToPurchase'),
    {
        fallback: null,
    }
);
